import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { TrafficReportProvider } from "../contexts/TrafficReportContext";
import { DialogProvider } from "../contexts/DialogContext";

export const TrafficReportComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<TrafficReportProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export default TrafficReportComposer;
